import React from "react";

export const footerMenus = [
  "All Departments",
  "Store Directory",
  "Careers",
  "Our Company",
  "Sell on Walmart.com",
  "Help",
  "Product Recalls",
  "Accessibility",
  "Tax Exempt Program",
  "Get the Walmart App",
  "Safety Data Sheet",
  "Terms of Use",
  "Privacy Notice",
  "California Supply Chain Act",
  "Your Privacy Choices",
  "Notice at Collection",
  "AdChoices",
  "Consumer Health Data Privacy Notices",
  "Brand Shop Directory",
  "Pharmacy",
  "Walmart Business",
  "#IYWYK",
  "Delete Account",
];

const Footer = () => {
  return (
    <>
      <div className="bg-[#E9F1FE] mt-10 py-10 flex flex-col gap-4 items-center justify-center">
        <p>We’d love to hear what you think!</p>
        <div className="flex w-fit items-center gap-1 font-semibold  px-4 h-10 rounded-full border hover:border-2 link border-black">
          <span>Give feedback</span>
        </div>
      </div>
      <div className="bg-[#002E99] px-[1rem] py-4 flex flex-col gap-8 pb-8">
        <div className="max-w-[1200px] m-auto grid grid-cols-2 place-items-center gap-x-6 gap-y-1 md:grid-cols-none md:flex md:justify-center md:items-center md:flex-wrap">
          {footerMenus.map((f, i) => {
            return (
              <div
                key={i}
                className="text-[.8rem] text-center md:whitespace-nowrap text-white"
              >
                {f}
              </div>
            );
          })}
        </div>
        <div className="text-white text-center text-[.7rem] max-w-[1000px] m-auto">
          © 2025 Walmart. The trademarks Walmart and the Walmart Spark design
          are registered with the US Patent and Trademark Office. All Rights
          Reserved.
        </div>
      </div>
    </>
  );
};

export default Footer;
